import { NumericField } from '@talos/kyoko';

export function createNumericField(name: string, value?: string) {
  return new NumericField({
    name,
    value,
    isRequired: true,
    minimum: '0',
  });
}
